module.exports = __webpack_public_path__ + "img/r-cb6-001.2853f62d.gif";